import { render, staticRenderFns } from "./SearchFiltersResetBtn.vue?vue&type=template&id=3a276285&scoped=true"
import script from "./SearchFiltersResetBtn.vue?vue&type=script&lang=js"
export * from "./SearchFiltersResetBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a276285",
  null
  
)

export default component.exports